import React from 'react'
import { PRESCRIPTION_COLORS_MAP } from '../../../inputComponents/common/color-utils'
import { PMPBodySectionItems } from './styledComponent'
import { getCasedHeadingTextBasedOnStyleOverrides } from 'src/mentor/components/PrescriptionMakingPage/printComponents/printComponents/prescriptionPrintableItems/util'
import { getSectionListFormatConfig, renderSectionLabelList } from './sectionListFormat'

export default function PrintableObservations({
  debug,
  observationRef,
  selectedObservations,
  debugHighlightStates,
  styleOverrides,
  listItemSeparator,
}) {
  const listCfg = getSectionListFormatConfig(styleOverrides, listItemSeparator)
  return (
    <PMPBodySectionItems
      ref={observationRef}
      debug={debug}
      debugColor={PRESCRIPTION_COLORS_MAP.observations?.color}
      debugHighlight={debugHighlightStates?.observations}
      borderLeft={styleOverrides?.borderLeft}
      paddingLeft={styleOverrides?.paddingLeft}
    >
      <span
        style={{
          fontSize: styleOverrides?.headingFontSize
            ? `${styleOverrides?.headingFontSize}px`
            : 'inherit',
          color: styleOverrides?.headingColor || styleOverrides?.color || 'inherit',
          fontWeight: 600,
        }}
      >
        <strong>
          {getCasedHeadingTextBasedOnStyleOverrides({
            headingText: 'Observations',
            styleOverrides,
          })}
        </strong>
      </span>
      <div
        style={{
          fontSize: styleOverrides?.fontSizePixels
            ? `${styleOverrides?.fontSizePixels}px`
            : 'inherit',
          color: styleOverrides?.color || 'inherit',
          wordWrap: 'break-word',
          wordBreak: 'break-word',
          overflowWrap: 'break-word',
          maxWidth: '100%',
        }}
      >
        {renderSectionLabelList(selectedObservations, listCfg)}
      </div>
    </PMPBodySectionItems>
  )
}
